<form #contactForm="ngForm" mailIdentityValidator>
    <ul class="list-none p-0 m-0">
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-4 font-medium">Imię i nazwisko*</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                <input type="text" pInputText [ngModel]="name" (ngModelChange)="nameChange.emit($event)" required minlength="2" #conName="ngModel" name="name"/>
                <small *ngIf="conName.invalid && (conName.dirty ||conName.touched)" class="p-error block">
                    <div *ngIf="conName?.errors?.['required']">
                        Imię i nazwisko jest wymagane.
                    </div>
                    <div *ngIf="conName.errors?.['minlength']">
                        Imię i nazwisko muszą mieć co najmniej 2 znaki.
                    </div>
                </small>
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-4 font-medium">E-mail*
                <i class="pi pi-info-circle" pTooltip="Na adres e-mail zostanie przesłane potwierdzenie złożenia wniosku" aria-hidden="true"></i>
            </div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="pi pi-at" aria-hidden="true"></i></span>
                    <input type="text" pInputText [ngModel]="email" (ngModelChange)="emailChange.emit($event)" #em="ngModel" required email name="email"/>
                </div>
                <small *ngIf="em.invalid && (em.dirty ||em.touched)" class="p-error">
                    <div *ngIf="em?.errors?.['required']">
                        Email jest wymagany
                    </div>
                    <div *ngIf="em?.errors?.['email']">
                        Niepoprawny email
                    </div>
                </small>
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-4 font-medium">Przepisz powyższy adres e-mail*</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="pi pi-at" aria-hidden="true"></i></span>
                    <input type="text" pInputText [(ngModel)]="contactReEmail" required email name="reEmail" #reemail="ngModel"/>
                </div>
                <small *ngIf="(reemail.invalid) && (reemail.dirty || reemail.touched)" class="p-error">
                    <div *ngIf="reemail?.errors?.['required']">
                        Email jest wymagany
                    </div>
                    <div *ngIf="reemail?.errors?.['email']">
                        Niepoprawny email
                    </div>
                    <div *ngIf="reemail?.errors?.['mailsNotMatch']">
                        Adresy email nie zgadzają się
                    </div>
                </small>
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-4 font-medium">Telefon komórkowy</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="pi pi-mobile" aria-hidden="true"></i></span>
                    <input type="text" pInputText [ngModel]="mobilePhone" (ngModelChange)="mobilePhoneChange.emit($event)" pattern="[\d\(\)\+-\s]+" #cm="ngModel" name="contactMobile"/>
                </div>
                <small *ngIf="cm?.errors?.['pattern']" class="p-error">
                    Niepoprawny numer telefonu komórkowego
                </small>
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-4 font-medium">Telefon stacjonarny</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="pi pi-phone" aria-hidden="true"></i></span>
                    <input type="text" pInputText [ngModel]="landlinePhone" (ngModelChange)="landlinePhoneChange.emit($event)" pattern="[\d\(\)\+-\s]+" #cp="ngModel" name="contactPhone"/>
                </div>
                <small *ngIf="cp?.errors?.['pattern']" class="p-error">
                    Niepoprawny numer telefonu stacjonarnego
                </small>
            </div>
        </li>
    </ul>
</form>
